"use client"

import Image from "next/image"
import { cn } from "@/lib/utils"

export type PhotoStripItem = {
  src: string
  alt: string
  size?: "sm" | "md" | "lg"
}

type PhotoStripSectionProps = {
  title?: string
  items: PhotoStripItem[]
  className?: string
}

const sizeClasses: Record<NonNullable<PhotoStripItem["size"]>, string> = {
  sm: "h-[150px] w-[104px] md:h-[210px] md:w-[140px]",
  md: "h-[186px] w-[126px] md:h-[264px] md:w-[172px]",
  lg: "h-[232px] w-[156px] md:h-[318px] md:w-[220px]",
}

export default function PhotoStripSection({ title, items, className }: PhotoStripSectionProps) {
  if (!items.length) return null

  return (
    <section className={cn("bg-white py-8 md:py-10", className)} aria-label={title || "Galeria de experiencias"}>
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        {title && <h2 className="sr-only">{title}</h2>}

        <div className="flex items-center justify-center gap-4 overflow-x-auto px-2 pb-2 md:gap-5 md:overflow-visible">
          {items.map((item, index) => {
            const size = item.size || (index === 2 ? "lg" : index === 1 || index === 3 ? "md" : "sm")

            return (
              <div
                key={`${item.src}-${index}`}
                className={cn(
                  "relative shrink-0 overflow-hidden rounded-[24px] bg-zinc-100 shadow-[0_14px_30px_rgba(15,23,42,0.14)]",
                  sizeClasses[size]
                )}
              >
                <Image
                  src={item.src}
                  alt={item.alt}
                  fill
                  sizes="(min-width: 1024px) 220px, 42vw"
                  className="object-cover object-center"
                />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
